module.exports = __webpack_public_path__ + "4f50bf99d4922018a535ea183a39ca3a.pdf";